import React from 'react';
import App from './js/app.js';

import ReactDOM from 'react-dom';
ReactDOM.render(<App />, document.getElementById('app'));